export class SessionStorage {
  private static readonly SESSION_STORAGE_KEY_PREFIX = '@GoSmartDiningSession:';

  private static isAvailable(): boolean {
    return typeof sessionStorage !== 'undefined';
  }

  public static getSessionString(key: string): string {
    if (!this.isAvailable()) {
      return null;
    }
    return sessionStorage.getItem(this.SESSION_STORAGE_KEY_PREFIX + key);
  }

  public static getSessionObject(key: string): any {
    if (!this.isAvailable()) {
      return null;
    }
    const raw = sessionStorage.getItem(this.SESSION_STORAGE_KEY_PREFIX + key);
    if (!raw) {
      return null;
    }
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }

  public static setSessionString(key: string, value: string) {
    if (!this.isAvailable()) {
      return;
    }
    sessionStorage.setItem(this.SESSION_STORAGE_KEY_PREFIX + key, value);
  }

  public static setSessionObject(key: string, value: any) {
    if (!this.isAvailable()) {
      return;
    }
    sessionStorage.setItem(
      this.SESSION_STORAGE_KEY_PREFIX + key,
      JSON.stringify(value)
    );
  }

  public static removeSession(key: string): void {
    if (!this.isAvailable()) {
      return;
    }
    sessionStorage.removeItem(this.SESSION_STORAGE_KEY_PREFIX + key);
  }

  public static resetSession(): void {
    if (!this.isAvailable()) {
      return;
    }
    sessionStorage.clear();
  }
}
